import type { Template } from "@/types";

export const SQ_04_H1_V3: Template[] = [
    {
        id: "sq-04-h1v3-01",
        name: "SQ 01 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 115, y: 0, width: 487, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 876, y: 71, width: 405, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 876, y: 347, width: 198, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1083, y: 347, width: 198, height: 299, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h1v3-02",
        name: "SQ 02 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 48, y: 168, width: 251, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 307, y: 168, width: 565, height: 381, rotation: 0, imageRotation: 0 },
            { id: "3", x: 880, y: 168, width: 251, height: 381, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1139, y: 168, width: 252, height: 381, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-04-h1v3-03",
        name: "SQ 03 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 68, y: 66, width: 309, height: 585, rotation: 0, imageRotation: 0 },
            { id: "2", x: 385, y: 66, width: 264, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 385, y: 252, width: 264, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 880, y: 66, width: 390, height: 585, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h1v3-04",
        name: "SQ 04 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 167, y: 70, width: 383, height: 577, rotation: 0, imageRotation: 0 },
            { id: "2", x: 861, y: 70, width: 419, height: 269, rotation: 0, imageRotation: 0 },
            { id: "3", x: 861, y: 347, width: 205, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1075, y: 347, width: 204, height: 300, rotation: 0, imageRotation: 0 }
        ],
    },

   {
        id: "sq-04-h1v3-05",
        name: "SQ 05 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_05.png",
        size: [1434, 717],
        style: {},
        slots: [
           { id: "1", x: 44, y: 170, width: 563, height: 377, rotation: 0, imageRotation: 0 },
           { id: "2", x: 614, y: 170, width: 252, height: 377, rotation: 0, imageRotation: 0 },
           { id: "3", x: 874, y: 170, width: 251, height: 377, rotation: 0, imageRotation: 0 },
           { id: "4", x: 1133, y: 170, width: 251, height: 377, rotation: 0, imageRotation: 0 }
       ],
    },

    {
        id: "sq-04-h1v3-06",
        name: "SQ 06 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 102, y: 86, width: 177, height: 269, rotation: 0, imageRotation: 0 },
            { id: "2", x: 102, y: 363, width: 177, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 287, y: 86, width: 336, height: 545, rotation: 0, imageRotation: 0 },
            { id: "4", x: 631, y: 86, width: 705, height: 545, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h1v3-07",
        name: "SQ 07 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 48, y: 206, width: 200, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 256, y: 206, width: 200, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 464, y: 206, width: 200, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 764, y: 148, width: 622, height: 421, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h1v3-08",
        name: "SQ 08 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 94, y: 77, width: 680, height: 563, rotation: 0, imageRotation: 0 },
            { id: "2", x: 781, y: 77, width: 361, height: 563, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1150, y: 77, width: 185, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1150, y: 363, width: 185, height: 277, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "sq-04-h1v3-09",
        name: "SQ 09 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 44, y: 147, width: 628, height: 423, rotation: 0, imageRotation: 0 },
            { id: "2", x: 755, y: 147, width: 202, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 971, y: 206, width: 202, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1187, y: 265, width: 202, height: 306, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "sq-04-h1v3-10",
        name: "SQ 10 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 47, y: 49, width: 413, height: 619, rotation: 0, imageRotation: 0 },
            { id: "2", x: 468, y: 49, width: 202, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 468, y: 362, width: 202, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 146, width: 628, height: 425, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h1v3-11",
        name: "SQ 11 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 45, y: 146, width: 628, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 764, y: 49, width: 413, height: 619, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1185, y: 49, width: 202, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1185, y: 362, width: 202, height: 306, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h1v3-12",
        name: "SQ 12 - H1V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h1_v3_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 149, y: 146, width: 138, height: 209, rotation: 0, imageRotation: 0 },
            { id: "2", x: 149, y: 362, width: 138, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 294, y: 146, width: 284, height: 425, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 146, width: 628, height: 425, rotation: 0, imageRotation: 0 }
        ],
    },


];

